/*============================================================================
  Localize

  This requires:
    - jquery
    - localize css
==============================================================================*/

var localize = (function(module, $) {

  'use strict';

  // Public functions
  var init, detect, buildString, onChange;

  // Private general variables
  var settings, defaults, cookie, $body;

  // Private methods
  var checkLocale, change, changePlaceholders, changeSelectOptions;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function(options) {
    // Default settings
    defaults = {
      locales: ['en', 'ja'],
      defaultLocale: 'en',
      currentLocale: null,
      changeSelector: '.localize__change-link',
      changeDataAttr: 'locale',
      onChange: function () {}
    };
    settings = {};

    // Override defaults with arguments
    $.extend(defaults, options);
    $.extend(settings, defaults);

    // General Selectors
    $body = $('body');

    // Detect current locale
    settings.currentLocale = detect();

    // Init body class
    $body.addClass('localize__' + settings.currentLocale);

    // Call change event onload
    $(document).ready(function() {
      change(settings.currentLocale);
    });

    // Update currency based on input on change
    $body.on('click', settings.changeSelector, function(e) {
      e.preventDefault();
      var locale = $(this).data(settings.changeDataAttr);
      locale = checkLocale(locale);
      change(locale);
    });

    $(document).keydown(function (e) {
      if (e.which == 69 && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopPropagation();

        var i = $.inArray(settings.currentLocale, settings.locales);
        i = (i + 1) % settings.locales.length;
        change(settings.locales[i]);

        return false;
      }
      return true;
    });
  };

  detect = function() {
    var saved = cookie.read();
    if (saved) {
      return saved;
    }

    var locale = navigator.userLanguage || navigator.language || navigator.browserLanguage || navigator.systemLanguage;
    if (locale) { locale = locale.substr(0,2).toLowerCase(); }

    locale = checkLocale(locale);

    cookie.write(locale);

    return locale;
  };

  change = function (locale) {
    var localeIndex = $.inArray(locale, settings.locales);

    $body.removeClass('localize__' + settings.currentLocale);
    $body.addClass('localize__' + locale);

    settings.currentLocale = locale;
    cookie.write(locale);

    // Support for input placholders
    changePlaceholders(locale, localeIndex);

    // Support for select options
    changeSelectOptions(locale, localeIndex);

    // Trigger change events
    settings.onChange(locale, localeIndex);
    $('body').trigger('localize.change', [locale, localeIndex]);
  };

  changePlaceholders = function (locale, localeIndex) {
    $('input[data-localize],textarea[data-localize]').each(function (el) {
      var $el = $(this);
      var localizeStrings = $el.data('localize').split('|');
      var localeString = localizeStrings[localeIndex] || localizeStrings[0];

      $el.prop('placeholder', localeString);
    });
  };

  changeSelectOptions = function (locale, localeIndex) {
    $('option[data-localize]').each(function (el) {
      var $el = $(this);
      var localizeStrings = $el.data('localize').split('|');
      var localeString = localizeStrings[localeIndex] || localizeStrings[0];

      $el.text(localeString);
    });
  };

  onChange = function (f) {
    // function is passed locale value
    settings.onChange = f || function () {};
  };

  buildString = function (value) {
    var localizeStrings = value.split('|');
    var build = [];
    $.each(settings.locales, function (i, locale) {
      var className = ['localize'];
      var localeString = localizeStrings[i] || localizeStrings[0];

      if (locale == settings.defaultLocale) {
        className.push('localize__default');
      }
      className.push('localize__' + locale);

      build.push('<span class="' + className.join(' ') + '">' + localeString + '</span>');

    });
    return build.join('');
  };

  checkLocale = function (locale) {
    if ($.inArray(locale, settings.locales) < 0) {
      locale = settings.defaultLocale;
    }
    return locale;
  };

  cookie = {
    configuration: {
      expires: 365,
      path: '/',
      domain: 'smartdoll.jp'
    },
    name: 'smartdoll-localize',
    write: function(locale) {
      Cookies.set(this.name, locale, this.configuration);
    },
    read: function() {
      return Cookies.get(this.name);
    },
    destroy: function() {
      Cookies.remove(this.name, this.configuration);
    }
  };

  module = {
    init: init,
    detect: detect,
    buildString: buildString,
    onChange: onChange
  };

  return module;

}(localize || {}, jQuery));
